/* import __COLOCATED_TEMPLATE__ from './channel-setup-card-link.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import { type Channel } from 'embercom/components/standalone/deploy/overview/channel-options';

export interface Args {
  channel: Channel;
}

const ChannelSetupCardLink = templateOnlyComponent<Args>();

export default ChannelSetupCardLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Overview::ChannelSetupCardLink': typeof ChannelSetupCardLink;
    'standalone/deploy/overview/channel-setup-card-link': typeof ChannelSetupCardLink;
  }
}
